import { useMutation } from "react-query";
import { axios } from "../../lib/request";
import externalAxios from "axios";

const readFileURL = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
};

export const useUploadImageMutation = ({ useQuery, name }) => {
    const [collection, setCollection] = useQuery();

    const { isLoading, mutateAsync } = useMutation(async (file) => {
        const fileURL = await readFileURL(file);
        const [ext] = file.name.split(".").reverse();
        const url = `${process.env.REACT_APP_API_SIGN_URL}/${ext.toLocaleLowerCase()}`;
        const response = await axios.get(url);
        const { data } = response || {};
        const options = { headers: { "Content-Type": file.type } };
        
        await externalAxios.put(data.signature, file, options);

        const [uuid, extension] = data.name.split(".");
        const mediaUrl = data?.name || fileURL;

        // Get existing URLs from the collection
        const existingValue = collection?.[name] || '';
        const existingUrls = existingValue ? existingValue.split(',').filter(url => url.trim()) : [];
        
        // Add the new URL to the list
        const updatedUrls = [...existingUrls, mediaUrl];

        // Update the collection with comma-delimited URLs
        await setCollection({
            [name]: updatedUrls.join(','),
        });

        return { uuid, extension, mediaUrl };
    });

    return { 
        isLoading, 
        mutateAsync,
    };
};
